// /* global __DEV__  */
import React, { Fragment } from 'react'
import FileUploader from '../Components/FileUploader'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'

// material ui icons
import Close from '@material-ui/icons/Close'
import LocalLibrary from '@material-ui/icons/LocalLibrary'
import Map from '@material-ui/icons/Map'
import DeleteIcon from '@material-ui/icons/Delete'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

// for attachments only
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
// import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
// import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
// import FormGroup from '@material-ui/core/FormGroup'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import Paper from '@material-ui/core/Paper'

import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
// import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItemCondense from 'components/Grid/GridItemCondense.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
// import CardContent from 'components/Card/CardContent'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardActions from '@material-ui/core/CardActions'
// should change the name to ...condense as well
import CustomInputCondense from 'components/CustomInput/CustomInputCondense'
import CustomMoneyInput from 'components/CustomInput/CustomMoneyInput'
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'
import DropdownDepartments from '../Components/DropdownDepartments'
import DropdownCompanies from '../Components/DropdownCompanies'
import DropdownExpenseType from '../Components/DropdownExpenseType'
import DropdownUsers from '../Components/DropdownUsers'
import Button from 'components/CustomButtons/Button.jsx'
import ReactToPrint from 'react-to-print'

import { remove, isEmpty, uniqBy, pick } from 'lodash'
// mask number input
// import NumberFormat from 'react-number-format'
// style for this view
import styleOfGegenralApplicationTemplate from '../../assets/jss/material-dashboard-pro-react/views/requestSubContractPayment'
//import { PrintStyle } from './print'

// imports for using table layout

import AppContext from '../../services/context'

// general api service
import {
  insertOne,
  updateOne,
  retrieveDataUsingGraphQL,
  retrieveBoundPath,
  signerResolver,
  retrieveSomeRoutes,
  fileDelete,
  fileDownload,
  getHighestLevelOfSingers,
  signingFlowHandling,
  handleApprove,
  handleReject,
  submitApplication,
  finishPaymentForApplication,
} from '../../services/generalServiceAPI'

import Signer from './Signer'
import Comments from './Comments'
import {
  noError,
  logger,
  generateOptionsFromStringArray,
  jsonPP,
  verifyMaxLength,
  titleCase,
  localTime,
  isShowActionButtons,
  isShowSaveButton,
  isShowSubmitButton,
  isShowArchivedButton,
  isShowPrintButton,
  statusNotAllowToBeModified,
  objectHash,
  getCurrentExchangeRate,
  getSingerTitle,
} from '../utility/utility'
import swal from 'sweetalert2'

import { GAT, GeneralData } from 'staticConfig.js'
// import { ProvidedRequiredArgumentsRule } from 'graphql'
// import classnames from 'classnames'
// import { create } from 'domain'
// import warning from 'warning'
// warning(true, 'how to')

const methodOfPaymentOptions = generateOptionsFromStringArray(GeneralData.methodsOfPayment)
const currencyOptions = generateOptionsFromStringArray(GeneralData.currency)

// printing page design starts from here
const styleOfPrintingGAT = {
  // @media print and (orientation: [portrait|landscape]) {}
  '@media print': {
    '@page': {
      margin: '0.5cm',
      // orientation: 'landscape'
    },
    margin: '0.5cm',
  },
  //calc("100% - 1cm") doesn't support? the theme is using it, it can be done somehow for sure
  page: { width: '100%', marginRight: '0.5cm', marginLeft: '0.5cm', marginTop: '1cm', marginBottom: '1cm' },
  table: { borderCollapse: 'collapse', border: '2px solid black', marginBottom: '15px', tableLayout: 'fixed' },
  title: { fontSize: '24px', textAlign: 'center', marginBottom: '20px', fontWeight: 'bold' },
  category: { fontSize: '18px', textAlign: 'center', marginBottom: '30px', fontWeight: 'bold' },
  label: { width: '49mm', border: '1px solid black', fontSize: '15px', textAlign: 'right', fontWeight: 'bold' },
  value: { width: '146mm', paddingLeft: '2mm', wordWrap: 'break-word', wordBreak: 'break-all' },
  description: { width: '146mm', paddingLeft: '2mm', wordWrap: 'break-word', wordBreak: 'break-all', whiteSpace: 'pre-line' },
  requestId: { float: 'left', fontSize: '12px', textAlign: 'left', fontWeight: 'bold', clear: 'right' },
  requestor: { width: '196mm', fontSize: '12px', textAlign: 'right', fontWeight: 'bold' },
  comment: { width: '195mm' },
  signer: { width: '60mm' },
  // signers: { position: "absolute", bottom: 0, pageBreakAfter: "always" }
  // signers: { pageBreakAfter: 'always', pageBreakInside: 'avoid' }
  signers: {},
}
class pageTemplate extends React.Component {
  // const defaultPageStyle = pageStyle === undefined
  // ? "@page { size: auto;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; } }"
  // : pageStyle;
  render = () => {
    const { classes, application } = this.props
    const {
      id,
      expenseOrProcurement,
      expenseType,
      company,
      department,
      payTo,
      methodOfPayment,
      currency,
      amount,
      description,
      comments,
      signers,
      signingPath,
      creator,
      createdOn,
      lastLevelToSign,
    } = application
    // const signerWidth = signers.length > 0 && signers.length < 5 ? 38 : 190 / signers.length
    const signerPerRow = 5
    const signerWidth = (38.5 * 5) / signerPerRow
    return (
      <div className={classes.page}>
        <div className={classes.title}>{`${company.name}`}</div>
        <div className={classes.category}>{`[${expenseOrProcurement} : ${expenseType.name}]`}</div>
        <div className={classes.requestId}>{'UUID: ' + id.toUpperCase().substr(id.length - 6)} </div>
        <div className={classes.requestor}>{creator ? `${titleCase(creator.name)}, ${localTime(createdOn)}` : ''} </div>
        <table className={classes.table}>
          <tbody>
            <tr>
              <td className={classes.label}>Department:</td>
              <td className={classes.value}>{department.name}</td>
            </tr>
            <tr>
              <td className={classes.label}>Pay To:</td>
              <td className={classes.value}>{payTo}</td>
            </tr>
            <tr>
              <td className={classes.label}>Amount:</td>
              <td className={classes.value}>{parseFloat(amount).toMoney()}</td>
            </tr>
            <tr>
              <td className={classes.label}>Currency:</td>
              <td className={classes.value}>{currency}</td>
            </tr>
            <tr>
              <td className={classes.label}>Method of Payment:</td>
              <td className={classes.value}>{methodOfPayment}</td>
            </tr>
            <tr>
              <td className={classes.label}>Description:</td>
              <td className={classes.description}>{description}</td>
            </tr>
          </tbody>
        </table>
        <table className={classes.signers}>
          <tbody>
            <tr>
              {signers.slice(0, lastLevelToSign > signerPerRow ? signerPerRow : lastLevelToSign).map((signer, key) => (
                <td className={classes.signer} style={{ width: `${signerWidth}mm` }} key={`td${key}`}>
                  <Signer
                    key={`singer${key}`}
                    signer={{ ...signer, role: signingPath && signingPath.levels[key] ? signingPath.levels[key].approverGroupName : '' }}
                  />
                </td>
              ))}
            </tr>
            <tr>
              {signers.slice(signerPerRow,lastLevelToSign > 2*signerPerRow ? 2*signerPerRow : lastLevelToSign).map((signer, key) => (
                <td className={classes.signer} style={{ width: `${signerWidth}mm` }} key={`td${key}`}>
                  <Signer
                    key={`singer${key}`}
                    signer={{ ...signer, role: signingPath && signingPath.levels[key] ? signingPath.levels[key].approverGroupName : '' }}
                  />
                </td>
              ))}
            </tr>
 
            <tr>
              {signers.slice(2*signerPerRow, lastLevelToSign).map((signer, key) => (
                <td className={classes.signer} style={{ width: `${signerWidth}mm` }} key={`td${key}`}>
                  <Signer
                    key={`singer${key}`}
                    signer={{ ...signer, role: signingPath && signingPath.levels[key] ? signingPath.levels[key].approverGroupName : '' }}
                  />
                </td>
              ))}
            </tr>
          </tbody>
        </table>
        <div className={classes.comment}>
          <Comments comments={comments} timeEllapsed={false} />
        </div>
      </div>
    )
  }
}
const GatPrintPage = withStyles(styleOfPrintingGAT)(pageTemplate)
// printing page design ends here

const initialData = {
  text: {
    title: 'Create Application',
    button: 'Submit',
  },
  data: {
    tableName: 'applications',
    id: '', // please keep it to be empty string which is the condition to decide if this is a new application or exisint one
    // type validation
    company: {},
    department: {},
    expenseType: {},
    toWhom: {},
    payTo: '',
    methodOfPayment: 'Cheque',
    currency: '',
    amount: 0.0,
    exchangeRate: 1.0,
    description: '',
    // Have id field when initialize the table data, but not using it at this moment, should it's out of sync, will use id to rearrange the order
    // table: initializeTable((test = true)),
    // this has to be ordered from hight to low since higher level will be rendered first
    signers: [],
    // placeholders, remove before save, add two fields initially to prevent from getting out of undefined error

    // -1 means for non-saved document, becomes 1 after submition, means the initiator has signed
    activeStep: -1,
    lastLevelToSign: -1, // always assume the initiator will sign first as the first step
    attachments: [],
    contributors: [],
    expenseOrProcurement: 'no default',
    // ...this.props.data
  },
  dataState: {
    // the empty ones are used to holding the place for error reporting
    expenseOrProcurement: 'required',
    expenseType: 'required',
    company: '',
    department: '',
    payTo: 'required',
    amount: 'required',
    //currency: 'required'
  },
}
const fieldsToHash = [
  'id',
  'creatorId',
  'expenseOrProcurement',
  'expenseType',
  'company',
  'department',
  'payTo',
  'amount',
  'methodOfPayment',
  'currency',
  'description',
]
class GeneralApplicationTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = initialData

    this.handleDropdown = this.handleDropdown.bind(this)
    this.getOnlyLabelFromDropdown = this.getOnlyLabelFromDropdown.bind(this)
    this.saveApplication = this.saveApplication.bind(this)
    this.addComment = this.addComment.bind(this)
    this.addContributor = this.addContributor.bind(this)
    this.getUploadedFiles = this.getUploadedFiles.bind(this)
    this.loadApplicationDetail = this.loadApplicationDetail.bind(this)
  }

  static contextType = AppContext

  isSubmitted = () => statusNotAllowToBeModified.includes(this.state.data.status)
  isFinished = () => this.state.data.status === 'completed' || this.state.data.status === 'rejected'
  isAbleToModifyAttachment = () => !this.isFinished() && this.state.data.creator.id === this.context.user.id

  setDataState(stateName, success, index) {
    const state = this.state.dataState
    if (typeof index === 'number') {
      state[stateName][index] = success ? 'success' : 'error'
    } else {
      state[stateName] = success ? 'success' : 'error'
    }

    this.setState({
      dataState: {
        ...state,
      },
    })
  }

  getUploadedFiles(files) {
    logger('GAT: getUploadedFiles', files)
    this.setState({
      data: {
        ...this.state.data,
        attachments: [...this.state.data.attachments, ...files],
      },
    })
  }

  changeNoValidation(event, stateName) {
    this.setState({
      data: {
        ...this.state.data,
        [stateName]: event.target.value,
      },
    })
  }
  async change(event, stateName, type, stateNameEqualTo, maxValue) {
    // return

    const { data } = this.state
    data[stateName] = event.target.value

    switch (type) {
      case 'max-length':
        if (verifyMaxLength(event.target.value, stateNameEqualTo + 1)) {
          this.setDataState(stateName, true)
        } else {
          this.setDataState(stateName, false)
        }
        break
      case 'money': //using money input
        this.setDataState(stateName, true)
        break
      default:
    }
    switch (stateName) {
      case 'expenseOrProcurement':
        await this.setDataState(stateName, true)
        await this.setDataState('expenseType', false)
        data['expenseType'] = ''
        break

      default:
    }
    const calculatedLastLevel = await getHighestLevelOfSingers({ ...data, amount: data.amount })
    // if no error, update
    data['lastLevelToSign'] = calculatedLastLevel > -2 ? calculatedLastLevel : data['lastLevelToSign']
    logger('[GAT][change]', data)
    this.setState({
      dirty: true,
      data: {
        ...this.state.data,
        ...data,
      },
    })
  }
  // handle all dropdowns with id fields, make their state to be success once clicked
  handleDropdown = (name) => async (value) => {
    const { data, dataState } = this.state
    //  logger('GAT:change',value)
    data[name] = value
    dataState[name] = isEmpty(value.label) ? 'error' : 'success'

    switch (name) {
      case 'company':
        data['department'] = ''
        dataState['department'] = 'required'
        break

      default:
    }

    await this.setState({
      dirty: true,
      data,
      dataState,
    })

    this.loadPathInfo().then(async () => {
      const { data } = this.state
      const calculatedLastLevel = await getHighestLevelOfSingers(data)
      data['lastLevelToSign'] = calculatedLastLevel > -2 ? calculatedLastLevel : data['lastLevelToSign']
      logger('GAT: loadPathInfo', calculatedLastLevel)
      // if no error, update
      if (calculatedLastLevel > -2) {
        this.setState({
          data: {
            ...this.state.data,
            ...data,
          },
        })
      }
    })
  }

  // for currency and method of payment, no need to record their IDs
  getOnlyLabelFromDropdown = (name) => (value) => {
    //  logger('GAT: loadPathInfo',value)
    const { data, dataState } = this.state
    data[name] = value.label
    if (isEmpty(value.label)) {
      dataState[name] = 'required'
    } else {
      dataState[name] = 'success'
      if (name === 'currency') {
        // if (value.label !== 'USD') {
        // pulling rate
        getCurrentExchangeRate('USD', value.label).then(async ({ rates }) => {
          const { data } = this.state
          // the following change the rates accordingly, prefer to use the most current one, fall back to the one set manually
          data['exchangeRate'] = typeof rates !== 'undefined' ?rates[value.label]: this.state.systemExchangeRates[value.label.toLowerCase()]
          const calculatedLastLevel = await getHighestLevelOfSingers(data)
          data['lastLevelToSign'] = calculatedLastLevel > -2 ? calculatedLastLevel : data['lastLevelToSign']
          this.setState((state, props) => ({ data }))
        })
        // }
      }
    }

    this.setState({
      dirty: true,
      data,
      dataState,
    })
  }
  async loadPathInfo() {
    // 1) decide if there is a bound path based upon typeOfApplication (fixed to be 0 for GAT and radio button), companyId (login user), expenseType (user input)
    // 2) if path is bound, retrieve it and report if any error
    // 3) resolve actual signers, report if any error
    const {
      initiatorId,
      data: { company, expenseType, department, expenseOrProcurement },
    } = this.state

    if (isEmpty(company.id) || isEmpty(expenseType.value)) return
    // 1) retrieve boundPath
    const variables = {
      typeOfApplicationId: 0,
      companyId: company.id,
      expenseTypeId: expenseType.value,
      departments: isEmpty(department) || isEmpty(department.id) ? [] : [department.id],
      expenseOrProcurement,
    }
    logger('[GAT][loadPathInfo][0]', { variables })
    const {
      data: { pathBinding },
    } = await retrieveBoundPath(variables)

    logger('GAT 411: loadPathInfo', pathBinding)
    // 2) resolve signers'
    logger('[GAT][loadPathInfo][1]', { pathBinding })
    if (isEmpty(pathBinding)) {
      // this is not an error, just means no routes yet
      this.setState({
        data: {
          ...this.state.data,
          //reset routes/singers, in case there are some values for them in state due to the previous choice
          routes: [],
          signers: [],
        },
      })
      //
      swal.fire({
        title: 'No signing path found!',
        html: `There is no signing path designed for <b>[${expenseType.label}]</b> in <b>[${company.label}]</b> for department <b>${
          department ? '[' + department.label + ']' : ''
        }</b>, please have your administrator to construct signing path first please.`,
        type: 'warning',
      })
    } else {
      let signers = await signerResolver(pathBinding[0].signingPath, initiatorId)

      await signers.sort((a, b) => a.level - b.level)

      // make sure companyId existed

      await retrieveSomeRoutes(variables).then(
        ({
          data: {
            someRoutes: { routes },
          },
        }) => {
          // Fetched routes are assigned to module level variable routes which will be leveraged by this.route to what's the highest level of approval

          this.setState({
            data: {
              ...this.state.data,
              routes,
              signers,
              signingPathId: pathBinding[0].signingPath.id,
              //必须加上这个，对于新application, 这是唯一获取路径的地方, 否则 SIGNER 不能正确显示
              signingPath: pathBinding[0].signingPath,
            },
          })
        }
      )
    }
  }
  parseApplicationData = (data) => {
    //  logger('GAT: loadPathInfo',data)
    switch (data.application.type.id) {
      case 0:
        logger('[GAT][parseApplicationData]: ', { data })
        const { company, expenseType, department, contributors, ...others } = data.application
        company.value = company.id
        company.label = company.name
        expenseType.value = expenseType.id
        expenseType.label = expenseType.name
        // 如果部门被删除了，会导致加载申请数据时出错
        // department.value = department.id
        // department.label = department.name
        // 该成如下
        // departmentForDisplay = department ? { ...department, value: department.id, label: department.name } : { value: '', label: '' }
        const tempContributors = isEmpty(contributors)
          ? []
          : contributors.map((c) => {
              return isEmpty(c)
                ? { value: '', label: '' }
                : {
                    value: c.id,
                    label: c.user.name,
                    email: c.user.email,
                  }
            })
        this.setState({
          text: {
            title: 'Update Application',
          },
          initiatorId: data.application.creator.id,
          data: {
            ...this.state.data,
            company,
            department: department ? { ...department, value: department.id, label: department.name } : { value: '', label: '' },
            expenseType,
            contributors: tempContributors,
            ...others,
          },
          dataState: {
            company: 'success',
            department: 'success',
            expenseType: 'success',
            payTo: 'success',
          },
        })
        break
      case 1:
        break
      default:
    }
  }
  loadApplicationDetail = async (id) => {
    const query = `
    query Application($id: ID!){
      application(id: $id) {
        id
        type{
          id
          name
          description
          short
        }
        description
        companyId
        company{
          id
          name
        }
        expenseTypeId
        expenseType{
          id
          name
        }
        expenseOrProcurement
        payTo
        departmentId
        department{
          id
          name
        }
        amount
        exchangeRate
        methodOfPayment
        currency
        signers {
          id
          level
          position
          fullName
          chineseName
          action
          email
          signedOn
          details {
            department {
              name
            }
          }
        }
        signingPath{
          levels{
            approverGroupName
          }
        }
        lastLevelToSign
        attachments {
          name
        }
        comments{
          user{
            name
          }
          comment
          wroteOn
        }
        contributors{
          id
          user {
            name
            email
          }

        }
        creatorId
        creator{
          id
          name
          email
        }
        createdOn
        activeStep
        lastModifiedOn
        status
        archived{
          by
          on
        }
      }
    }
  `
    const applicationId = isEmpty(id) ? this.state.data.id : id
    await retrieveDataUsingGraphQL(query, { id: applicationId })
      //  logger('GAT: loadApplicationDetail',data)
      // await this.parseApplicationData(data)
      .then(async (response) => {
        if (response.status === 200) {
          return response.json()
        } else {
          throw new Error(JSON.stringify(await response.json()))
        }
      })
      .then(({ data }) => {
        if (isEmpty(data.application)) throw new Error('Unable to fetch application details.')
        // Based upon the application type, load data accordingly
        // console.log('caller is' + this.callee.caller.toString())
        logger('[GAT][loadApplicationDetail]: ', data)
        this.parseApplicationData(data)
        this.setState({ hash: objectHash(pick(this.state.data, fieldsToHash)) })
      })
      .catch((e) => {
        swal
          .fire({
            title: 'Attention',
            html: `Unalbe to fetch application details with the application id ${id}, it could have been withdrawn or deleted by the applicant or administrator.`,
            type: 'warning',
          })
          .then((v) => this.props.history.push('/dashboard'))
      }) //error report
  }
  componentWillUnmount() {
    this.context.applicationId = ''
  }
  //pick up all the predefined conditional fields, the key should align with
  async componentDidMount() {
    //  logger('GAT: loadApplicationDetail',this.context.user)
    let query
    let variables
    let initiatorId = this.context.user.id
    let systemExchangeRates

    // for existing application, the applicaiton id should be in this.context.application.id
    //    1. if submitted, locks up all the button and fields
    //    2. if not submitted yet, treat as new application
    // for new application, initialize the form and buttons

    // existing application ** make sure clear this data in context when create new application ***

    //  logger('GAT: loadApplicationDetail','general application mount', this.context)
    // instead of passing id in context, it can be passing using query parameter
    // load data for an existing application

    if (this.props.match.params.id) {
      //this await is necessary, otherwise the activeStep in next step will be unavailable
      await this.loadApplicationDetail(this.props.match.params.id)
      //  logger('GAT: loadApplicationDetail',this.state.data)
    } else if (isEmpty(this.state.data.id) || this.state.data.activeStep < 0) {
      // 改用 else if, 把 新建和已存的申请完全隔离， 要不然当前用户的公司部门属性会覆盖已有的

      //  logger('GAT: loadApplicationDetail',this.state.data)

      // load type of applicatin data only for a new or modifiable application
      // need to get conditions for new application and a draft application
      // get basic info of application

      // ** maybe just do this for the totally new application, a saved one should have the application type info
      //    the new issue is that what if they changed the type again before submit
      // *** no need, this type indicates GAT/TO etc. so once it's set, that's it, when id exists, means at least it's saved once , then
      //     no need to load this again, so the condition could be just !this.context.applicationId

      // *** should lock up company/deparment, this is a misunderstanding, they are already be able acted as a condition in path design, here just get the value
      // *** 1) expenseType and producment Type drives the path selection, so this has to be done dynamically instead of load here once,
      // *** 2) signers have to be dynamically calculated as well
      query = `
        query exchangeRates{
          exchangeRates {
            cad
            hk
            rmb
            cny
            eur
            id
          }
        }
      `   
      await retrieveDataUsingGraphQL(query, {})
        .then((response) => response.json())
        .then(({ data }) => { this.setState({systemExchangeRates : {
          usd:1.000, 
          cad:1.000,
          eur:1.000,
          cny:1.000,
          hk:1.000,
          ...data.exchangeRates}})}
        )

      query = `
        query typeOfApplication($id: Int!){
          typeOfApplication(id: $id) {
            id
            name
            description
            short
          }
        }
      `
      variables = { id: 0 } // id 0 here means general template, seems regular id field is does needed since there will be needed in design phase
      await retrieveDataUsingGraphQL(query, variables)
        .then((response) => response.json())
        .then(({ data }) => {
          let companyId,
            companyName,
            departmentId,
            departmentName,
            currency = 'USD'
          if (isEmpty(this.context.user.company)) {
            logger('[GAT][retrieveDataUsingGraphQL]', `Missing company info for ${this.context.user}.`, true)
          } else {
            const { id, name, country } = this.context.user.company
            companyId = id
            companyName = name
            try {
              currency = GeneralData.country.filter((c) => c.name === country)[0].currency
            } catch (e) {
              logger(`[GAT][DidMount]: no currency found for ${companyName}`)
            }
            if (currency !== 'USD') {
              // pulling rate for the first time
              getCurrentExchangeRate('USD', currency).then(({ rates }) => 
                { 
                  if( typeof rates !== 'undefined') {
                    return this.setState((state, props) => ({ data: { ...state.data, exchangeRate: rates[currency] } }))
                  } else {
                    // swal.fire({ title: 'Error encountered while pulling the current exchange rate', html: 'Most likely this is because the currency exchange to which you are connecting is temprarily out of service, this could affect the final approver for your request,  you can still go ahead without an exchange rate applied (notice Rate: 1.0000 at the top-right corner) if you are okay with the final approver picked up by the system automatically', type: 'warning' })
                    return this.setState((state, props) => ({ data: { ...state.data, exchangeRate: state.systemExchangeRates[currency.toLowerCase()] } }))
                  }
                }
              )
            }
          }
          if (isEmpty(this.context.user.department)) {
            logger('[GAT][retrieveDataUsingGraphQL]', `Missing department info for ${this.context.user}.`, true)
          } else {
            departmentId = this.context.user.department.id
            departmentName = this.context.user.department.name
          }

          this.setState({
            text: {
              title: 'Create New Application',
            },
            initiatorId,
            data: {
              ...this.state.data,
              type: data.typeOfApplication,
              currency,
              //defaultCurrency:currency, // used to decide if currency is changed from default
              company: {
                id: companyId,
                value: companyId,
                label: companyName,
              },
              department: {
                id: departmentId,
                value: departmentId,
                label: departmentName,
              },
            },
            dataState: {
              ...this.state.dataState,
              company: isEmpty(companyId) ? 'required' : 'success',
              department: isEmpty(departmentId) ? 'required' : 'success',
            },
          })
        })
        .catch((e) => {
          logger('[GAT][componentDidMount] - ', e.message, true)
          logger('[GAT][componentDidMount] - ', this.context, true)
        })
      //  logger('GAT: componentDidMount',this.state.data)
      //this is a copied piece from handleDropdown, should make them 1 piece
    }
    // console.log('test', !this.state.data.signers)
    if (isEmpty(this.state.data.signers)) {
      await this.loadPathInfo().then(async () => {
        const { data } = this.state
        const calculatedLastLevel = await getHighestLevelOfSingers(data)
        data['lastLevelToSign'] = calculatedLastLevel > -2 ? calculatedLastLevel : data['lastLevelToSign']

        if (calculatedLastLevel > -2) {
          await this.setState({
            data: {
              ...this.state.data,
              ...data,
            },
          })
        }
      })
    }
    // get hash code
    this.setState({ hash: objectHash(pick(this.state.data, fieldsToHash)) })
  }
  saveApplication(isSubmitApplication) {
    // for loaded existing data, the dataState may not reflect the fact, so walk through the data tree to repopulate the state info
    //  1) assume existing application when data.id is populated
    //  2) different type of appplication will have different set of mandatory fields, so use switch

    // let mandatoryFields = []
    // // do need this since they are initially set to 'error' or 'required' to force user to input
    // if (!isEmpty(this.state.data.id)) {
    //   switch (this.state.data.type.id) {
    //     //GAT
    //     case 0:
    //       mandatoryFields = ['company', 'expenseType', 'department', 'payTo', 'amount']

    //       break
    //     case 1:
    //       break
    //     default:
    //   }
    //   mandatoryFields.map(field => {
    //     if (!isEmpty(this.state.dataState[field])) this.setState({ dataState: { [field]: 'success' } })
    //   })
    // }
    // pick(this.state.data, mandatoryFields)
    try {
      if (isSubmitApplication && isEmpty(this.state.data.signers)) throw new Error('Can NOT submit yet, no signer available.')
      if (noError(this.state.dataState)) {
        const { data } = this.state
        const {
          company,
          department,
          expenseType,
          // keep the application data, need the type info - each type of application has different set of data in the collection.
          // have to load the data in DidMount accordingly.
          // application,
          signingPath,
          // remove routes and signers before save,
          toWhom,
          routes,
          signers,
          comment,
          contributors,
          status,
          // repopulate activeStep accordingly
          creatorId,
          ...keptData
        } = data

        const dataToSave = {
          status: 'draft',
          companyId: company.id,
          departmentId: department.id,
          expenseTypeId: expenseType.value,
          signers: (() => {
            //check if all the signers exist only when submit
            if (isSubmitApplication) {
              if (isEmpty(signers)) {
                throw new Error('Does not know how to route this applicaiton yet, please consult your administrator.')
              } else if (
                signers.slice(0, this.state.data.lastLevelToSign - 1).reduce((agg, signer) => {
                  return agg || isEmpty(signer.id)
                }, false)
              ) {
                throw new Error(
                  'Missing a signer currently, it might be caused by temprarily no one available in a department or group or due to some system settings, please make your administrator be aware of this situation, it might be better just to take a screenshot to email to them.'
                )
              } else {
                return signers
              }
            }
          })(), // only save signers when isSubmitApplication
          ...keptData,
          archived: false,
          //prevent someone else override the original initiator
          creatorId: isEmpty(creatorId) ? this.context.user.id : creatorId,
        }
        logger('[GAT][saveApplication]: ', { dataToSave })
        const insertOrModify = data.id && data.id !== '' ? updateOne : insertOne

        // feels like the first then() and catch() could be moved into general service
        insertOrModify(dataToSave)
          .then((response) => {
            if (response.ok) {
              return response.json()
            } else
              swal(response.url, {
                icon: 'error',
              })
          })
          .then(async (res) => {
            //  logger('GAT: saveApplication',res)
            const { id } = res
            const recordId = id ? id : this.state.data.id
            const creator = {
              id: this.context.user.id,
              name: titleCase(this.context.user.firstname + ' ' + this.context.user.lastname),
              email: this.context.user.email,
            }
            // const creatorName = titleCase(this.context.user.firstname + ' ' + this.context.user.lastname)
            // const creator = { id: this.context.user.id, name: creatorName, email: this.context.user.email }

            if (isSubmitApplication) {
              // it's better if can take res directly, but it's not from graphql, so needs a lot to be resolved.
              // signingFlowHandling({
              //   action: 'submitted',
              //   application: { ...this.state.data, id: recordId, creator },
              //   reason: `${creatorName} submitted this application`
              // })
              submitApplication({ application: { ...this.state.data, id, creator } }).then(async (data) => {
                logger('[GAT][saveApplication]:', { data })

                if (data.code !== 0) {
                  swal.fire({ title: 'Error in GAT', html: data.message, type: 'error' })
                } else {
                  await this.loadApplicationDetail(recordId)
                  await swal.fire({ title: 'Success', html: 'This record has beend submitted - ' + recordId, timer: 2000, type: 'success' })
                  this.setState({
                    hash: objectHash(pick(this.state.data, fieldsToHash)),
                    data: {
                      ...this.state.data,
                      status: 'submitted',
                    },
                  })
                }
              })
            } else {
              // only show save success message for saving draft, so just 1 message per action
              await swal.fire({ title: 'Success', html: 'This record has beend saved - ' + recordId, timer: 2000, type: 'success' })
              await this.loadApplicationDetail(recordId)
              // 把没存的 signers 加回来， 这个块儿应该只是对尚未提交的申请有效， 一旦提交，save and submit 应该都隐藏了， 素以应该没问题
              // 如果不小心 这个块儿 在提交之后被执行了，那么有可能把已经签字的数据给覆盖掉， 要注意
              const data = {
                ...this.state.data,
                signers,
              }
              this.setState({
                data,
                hash: objectHash(pick(this.state.data, fieldsToHash)),
              })
            }
            this.context.pullingNumbers()
          })
        // .catch(e => swal('Error', `General API throw error: ${e}`), 'error')
      } else {
        // swal('Error', 'Please fix the error or fill in all the mandatory fields.', 'error')
        //throw new Error('Please make sure there is NO error in all the input fields and fill up all the mandatory ones.')
      }
    } catch (e) {
      logger('[GAT][saveApplication]:', e, true)
      swal.fire({ title: 'Error', html: e.message, type: 'error' })
    }
  }
  addComment = () => {
    const { tableName, id, comment, toWhom } = this.state.data
    if (isEmpty(comment)) {
      swal.fire({ title: 'Missing information', html: 'Comment can not be empty.', type: 'info' })
      return
    }
    if (isEmpty(toWhom)) {
      swal.fire({ title: 'Missing information', html: 'Please choose a user to whom the comment is addressed. ', type: 'info' })
      return
    }
    updateOne({
      tableName,
      id,
      comments: { userId: this.context.user.id, comment },
      toWhom: { id: toWhom.value, name: toWhom.label, email: toWhom.email },
      fromWhom: { id: this.context.user.id, name: this.context.user.name },
      application: { id: this.state.data.id, description: this.state.data.description, type: this.state.data.type },
      command: 'push',
      commandKey: 'comments',
    })
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else
          swal.fire({
            html: response.url,
            type: 'error',
          })
      })
      .then((res) => {
        this.loadApplicationDetail(id)
        swal
          .fire({ title: 'Success', html: 'This comment has beend added ', type: 'success', timer: 1000 })
          .then(this.setState({ data: { ...this.state.data, comment: '' } }))
      })
      .catch((e) => swal.fire({ title: 'Error', html: e.message, type: 'error' }))
  }
  addContributor = (name) => (value) => {
    const { contributors } = this.state.data

    const duplicatesRemoved = uniqBy(contributors, (c) => c.value)
    // console.log(contributors, duplicatesRemoved)
    if (duplicatesRemoved.length < contributors.length) {
      //this is unnecessary since the autocompletion drop has already taken away the chosen one from the list,
      // but this is good piece of code, leave it here
      swal.fire({ title: 'Warning', html: 'Do not try to add the user who is already in the list.', type: 'warning' })
    } else {
      const { id, firstname, lastname } = this.context.user
      signingFlowHandling({
        action: 'invite',
        application: this.state.data,
        currentUser: { id, fullName: `${firstname} ${lastname}` },
        contributors: value,
      }).then((data) => {
        if (data.code === 0) {
          this.setState({ data: { ...this.state.data, contributors: value } })
          swal.fire({ title: 'Success', html: data.message, type: 'success', timer: 2000 }) //.then(() => this.props.refresh()})
        } else {
          // throw new Error(data.message)
          swal.fire({ title: 'Error', html: data.message, type: 'error', timer: 2000 })
        }
      })
    }
  }

  render() {
    const attachmentsPanelLayout = [10, 2]
    const { classes } = this.props
    const getCornerInfo = () =>
      !isEmpty(this.state.data.id)
        ? `UUID: ${this.state.data.id.toUpperCase().substr(this.state.data.id.length - 6)} [${titleCase(this.state.data.creator.name)}]`
        : ''
    const lengthOfSigner = [12, 3, 3, 4, 3, 2, 2, 3, 3, 4, 2, 2, 2]
    return (
      // <div ref={el => (this.componentRef = el)}>

      <GridContainer>
        <Card>
          <CardHeader color='rose' icon>
            <CardIcon color='rose'>
              <LocalLibrary />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>{this.state.text.title}</h4>
          </CardHeader>
          <CardBody>
            <form>
              <GridContainer>
                {/** line 0  expense/procument */}

                <GridItemCondense xs={11} md={4} lg={3}>
                  <RadioGroup
                    aria-label='position'
                    name='expenseOrProcurement'
                    value={this.state.data.expenseOrProcurement}
                    onChange={(event) => this.change(event, 'expenseOrProcurement')}
                    row
                  >
                    <FormControlLabel
                      value='Expense'
                      control={<Radio color='primary' />}
                      disabled={this.isSubmitted()}
                      label='Expense'
                      labelPlacement='start'
                      style={{ marginLeft: 'auto' }}
                    />

                    <FormControlLabel
                      value='Procurement'
                      control={<Radio color='primary' />}
                      disabled={this.isSubmitted()}
                      label='Procurement'
                      labelPlacement='start'
                    />
                  </RadioGroup>
                </GridItemCondense>
                <GridItemCondense xs={1} md={7} lg={8} />
                <GridItemCondense xs={12} md={1} lg={1}>
                  {this.state.data.currency !== '' && this.state.data.currency !== 'USD' ? (
                    <FormLabel className={classes.labelCondense} disabled>
                      Rate: {this.state.data.exchangeRate ? this.state.data.exchangeRate.toFixed(4) : 'N/A'}
                    </FormLabel>
                  ) : (
                    ''
                  )}
                </GridItemCondense>
                <GridItemCondense xs={12} />
                {/** line 1.1  ccompany/deparment*/}

                <GridItemCondense xs={3} sm={6} md={2}>
                  <FormLabel className={classes.labelCondense}>Type:</FormLabel>
                </GridItemCondense>
                <GridItemCondense xs={8} sm={6} md={5}>
                  <DropdownExpenseType
                    id='expenseType'
                    isDisabled={this.isSubmitted()}
                    subType={this.state.data.expenseOrProcurement}
                    value={this.state.data.expenseType}
                    onChange={this.handleDropdown('expenseType')}
                  />
                </GridItemCondense>
                <GridItemCondense xs={1} sm={0} md={5}></GridItemCondense>
                {/** line 1.2  ccompany/deparment*/}
                <GridItemCondense xs={3} sm={6} md={2}>
                  <FormLabel className={classes.labelCondense}>Company:</FormLabel>
                </GridItemCondense>
                <GridItemCondense xs={8} sm={6} md={5}>
                  <DropdownCompanies id='company' isDisabled={this.isSubmitted()} value={this.state.data.company} onChange={this.handleDropdown('company')} />
                </GridItemCondense>

                <GridItemCondense xs={1} sm={0} md={5}></GridItemCondense>
                <GridItemCondense xs={3} sm={6} md={2}>
                  <FormLabel className={classes.labelCondense}>Department:</FormLabel>
                </GridItemCondense>
                <GridItemCondense xs={8} sm={6} md={5}>
                  <DropdownDepartments
                    id='department'
                    isDisabled={this.isSubmitted()}
                    companyId={this.state.data.company.id}
                    value={this.state.data.department}
                    onChange={this.handleDropdown('department')}
                  />
                </GridItemCondense>
                <GridItemCondense xs={1} sm={0} md={5}></GridItemCondense>
                {/** line 3 payto */}
                <GridItemCondense xs={3} sm={6} md={2}>
                  <FormLabel className={classes.labelCondense}>Pay To:</FormLabel>
                </GridItemCondense>
                <GridItemCondense xs={8} sm={6} md={5}>
                  <CustomInputCondense
                    id='payTo'
                    success={this.state.dataState.payTo === 'success'}
                    error={this.state.dataState.payTo === 'error'}
                    disabled={this.isSubmitted()}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment:
                        this.state.dataState.payTo === 'error' ? (
                          <InputAdornment position='end'>
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,

                      onChange: (event) => this.change(event, 'payTo', 'max-length', GAT.input.payToLength ? GAT.input.payToLength : 50),
                      value: this.state.data.payTo,
                      type: 'text',
                    }}
                  />
                </GridItemCondense>

                <GridItemCondense xs={1} sm={0} md={5}></GridItemCondense>
                <GridItemCondense xs={3} sm={6} md={2}>
                  {/* ({this.state.data.currency}) */}
                  <FormLabel className={classes.labelCondense}>Amount:({this.state.data.exchangeRate ? this.state.data.exchangeRate.toFixed(4) : 'N/A'})</FormLabel>
                </GridItemCondense>
                <GridItemCondense xs={8} sm={6} md={5}>
                  <CustomMoneyInput
                    id='amount'
                    formControlProps={{
                      fullWidth: true,
                    }}
                    disabled={this.isSubmitted()}
                    inputProps={{
                      onChange: (event) => this.change(event, 'amount', 'money'),
                      value: this.state.data.amount,
                      type: 'text',
                    }}
                  />
                </GridItemCondense>
                <GridItemCondense xs={1} sm={0} md={5}></GridItemCondense>
                <GridItemCondense xs={3} sm={6} md={2}>
                  <FormLabel className={classes.labelCondense}>Currency:</FormLabel>
                </GridItemCondense>
                <GridItemCondense xs={8} sm={6} md={5}>
                  <AutoCompleteDropdown
                    value={this.state.data.currency}
                    isDisabled={this.isSubmitted()}
                    options={currencyOptions}
                    placeholder={'...'}
                    onChange={this.getOnlyLabelFromDropdown('currency')}
                  />
                </GridItemCondense>
                <GridItemCondense xs={1} sm={0} md={5}></GridItemCondense>
                <GridItemCondense xs={3} sm={6} md={2}>
                  <FormLabel className={classes.labelCondense}>Method of Payment:</FormLabel>
                </GridItemCondense>
                <GridItemCondense xs={8} sm={6} md={5}>
                  <AutoCompleteDropdown
                    value={this.state.data.methodOfPayment}
                    isDisabled={this.isSubmitted()}
                    options={methodOfPaymentOptions}
                    placeholder={'Select a payment method'}
                    onChange={this.getOnlyLabelFromDropdown('methodOfPayment')}
                  />
                </GridItemCondense>
                <GridItemCondense xs={1} sm={0} md={5}></GridItemCondense>
                {/** line 5  description*/}
                <GridItemCondense xs={2} sm={6} md={2}>
                  <FormLabel className={classes.labelCondense}>Description:</FormLabel>
                </GridItemCondense>
                <GridItem xs={9} sm={6} md={5}>
                  <CustomInputCondense
                    id='description'
                    formControlProps={{
                      fullWidth: true,
                    }}
                    disabled={this.isSubmitted()}
                    inputProps={{
                      onChange: (event) => this.changeNoValidation(event, 'description'),
                      value: this.state.data.description,
                      multiline: true,
                      rows: 3,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={0} md={5} />
                {/** line of attachments */}
                {this.state.data.id !== '' ? (
                  <GridItem xs={12} sm={12} md={12}>
                    <ExpansionPanel>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading}>Expand this to see all the attachments or add files</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <GridContainer>
                          <GridItem xs={attachmentsPanelLayout[0]}>
                            <Paper className={classes.attachments}>
                              {this.state.data.attachments.map((file, key) => (
                                <List dense={true} key={'fileList' + key}>
                                  <ListItem
                                    button
                                    // component="a"
                                    // href={`/file/${this.state.data.id}/${
                                    //   file.name
                                    // }`}
                                    onClick={() => fileDownload(this.state.data.id, file.name).then((data) => logger('SigningFlow', data))}
                                  >
                                    <ListItemIcon>
                                      <Map />
                                    </ListItemIcon>

                                    <ListItemText primary={`${file.name}`} secondary={false ? 'Secondary text' : null} />
                                    {this.isAbleToModifyAttachment() ? (
                                      <ListItemSecondaryAction>
                                        <IconButton
                                          aria-label='Delete'
                                          onClick={() =>
                                            swal
                                              .fire({
                                                title: 'Are you sure?',
                                                html: 'Once deleted, you will not be able to recover this record!',
                                                type: 'warning',
                                                buttons: true,
                                                dangerMode: true,
                                              })
                                              .then((willDelete) => {
                                                if (willDelete) {
                                                  fileDelete(this.state.data.id, file.name).then((data) => {
                                                    const { attachments } = this.state.data
                                                    remove(attachments, (existedFile) => existedFile.name === file.name)
                                                    this.setState({
                                                      data: {
                                                        ...this.state.data,
                                                        attachments,
                                                      },
                                                    })
                                                  })
                                                }
                                              })
                                          }
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </ListItemSecondaryAction>
                                    ) : (
                                      ''
                                    )}
                                  </ListItem>
                                </List>
                              ))}
                            </Paper>
                          </GridItem>
                          <GridItem xs={attachmentsPanelLayout[1]}>
                            {this.isAbleToModifyAttachment() ? (
                              <FileUploader rightAlign dir={this.state.data.id} attached={this.state.data.attachments} onChange={this.getUploadedFiles} />
                            ) : (
                              ''
                            )}
                          </GridItem>
                          {/* <GridItem xs={6}>{!this.isFinished() ? <Upload /> : ''}</GridItem> */}
                        </GridContainer>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </GridItem>
                ) : (
                  <Fragment />
                )}
                {/** line of comments */}
                {/* <GridItem xs={12} sm={2} md={2}>
                          <FormLabel className={classes.labelCondense}>Comment</FormLabel>
                        </GridItem> */}
                {this.isSubmitted() ? (
                  <Fragment>
                    {/* comment row */}
                    <GridItem xs={12} sm={12} md={12}>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>Expand this to see all the comments or add comment</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <GridContainer>
                            <GridItem xs={12}>
                              <Comments comments={this.state.data.comments} />
                            </GridItem>
                            <GridItem xs={7}>
                              <TextField
                                className={classes.textarea}
                                id='comment'
                                label='type your comment here. (shift+enter for starting a new line)'
                                multiline
                                disabled={this.isFinished()}
                                rowsMax='4'
                                value={this.state.data.comment}
                                onChange={(event) => this.changeNoValidation(event, 'comment')}
                                fullWidth
                                margin='normal'
                                // helperText="hello"
                                variant='filled'
                              />
                            </GridItem>
                            <GridItem xs={3}>
                              <DropdownUsers
                                id='toWhom'
                                isDisabled={this.isFinished()}
                                loose
                                value={this.state.data.toWhom}
                                onChange={this.handleDropdown('toWhom')}
                              />
                            </GridItem>
                            <GridItem xs={2}>
                              {this.isFinished() ? (
                                ''
                              ) : (
                                <Button color='rose' className={classes.buttons} onClick={() => this.addComment()}>
                                  Add Comment
                                </Button>
                              )}
                            </GridItem>
                          </GridContainer>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    </GridItem>
                    {/* contributor row */}
                    <GridItem xs={12} sm={12} md={12}>
                      <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>Expand this to see contributors or add contributor</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <GridContainer>
                            <GridItem xs={12}>
                              <DropdownUsers
                                id='contributors'
                                isDisabled={this.isFinished()}
                                loose
                                isMulti
                                value={this.state.data.contributors}
                                onChange={this.addContributor('contributors')}
                              />
                            </GridItem>
                          </GridContainer>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    </GridItem>
                  </Fragment>
                ) : (
                  <Fragment />
                )}
                {/** line of singers */}
                {this.state.data.signers
                  .sort((a, b) => a.level - b.level)
                  .map((signer, key) =>
                    signer.level <= this.state.data.lastLevelToSign ? (
                      <GridItem key={`singer-grid${key}`} xs={6} md={3}>
                       {/**{lengthOfSigner[this.state.data.lastLevelToSign]}>**/}
                        <Signer
                          key={`singer${key}`}
                          signer={{
                            ...signer,
                            role: getSingerTitle(signer, key, this.state.data.signingPath),
                          }}
                        />
                      </GridItem>
                    ) : (
                      ''
                    )
                  )}
              </GridContainer>
            </form>
          </CardBody>
          <CardActions className={classes.actions} disableActionSpacing>
            <FormLabel className={classes.labelCondense}>{getCornerInfo()}</FormLabel>

            {isShowSaveButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash) ? (
              <Button color='rose' style={{ marginLeft: 'auto' }} onClick={() => this.saveApplication(false)}>
                Save
              </Button>
            ) : (
              ''
            )}

            {isShowSubmitButton(this.state.data, this.context.user.id) ? (
              <Button
                color='rose'
                style={isShowSaveButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash) ? {} : { marginLeft: 'auto' }}
                onClick={() => this.saveApplication(true)}
              >
                Submit
              </Button>
            ) : (
              ''
            )}
            {/* 同意/拒绝按钮 */}
            {isShowActionButtons(this.state.data, this.context.user.id) ? (
              <Fragment>
                <Button
                  color='rose'
                  style={{ marginLeft: 'auto' }}
                  onClick={() =>
                    handleApprove({ application: this.state.data, refresh: this.loadApplicationDetail, pullingNumbers: this.context.pullingNumbers })
                  }
                >
                  Approve
                </Button>
                <Button
                  color='rose'
                  onClick={() =>
                    handleReject({ application: this.state.data, refresh: this.loadApplicationDetail, pullingNumbers: this.context.pullingNumbers })
                  }
                >
                  Reject
                </Button>
              </Fragment>
            ) : (
              ''
            )}
            {/* archived 按钮 */}
            {isShowArchivedButton(this.state.data, this.context.user.roleID === 97 ? 'Expense' : 'Procurement') ? (
              <Fragment>
                <Button
                  color='rose'
                  style={{ marginLeft: 'auto' }}
                  onClick={() =>
                    finishPaymentForApplication({
                      id: this.state.data.id,
                      tableName: this.state.data.tableName,
                      archived: {
                        by: this.context.user.id,
                        on: new Date(),
                      },
                      refetch: this.loadApplicationDetail,
                    })
                  }
                >
                  Archived
                </Button>
              </Fragment>
            ) : (
              ''
            )}
            {/* 打印按钮 */}
            {this.state.data.id !== '' ? (
              <ReactToPrint
                trigger={() => (
                  <Button
                    color='rose'
                    // style={isShowSaveButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash) ? {} : { marginLeft: 'auto' }}
                    // className={['rejected', 'completed', 'submitted'].includes(this.state.data.status) ? classes.buttons : ''}
                    style={
                      isShowPrintButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash)
                        ? { marginLeft: 'auto' }
                        : { marginLeft: 'unset' }
                    }
                    // onClick={() => handlePrint({ application: this.state.data })}
                  >
                    Print
                  </Button>
                )}
                content={() => this.componentRef}
                pageStyle='@page { size: auto;  margin: 5mm; }'
              />
            ) : (
              ''
            )}
          </CardActions>
        </Card>
        <div style={{ display: 'none' }}>
          <GatPrintPage application={this.state.data} ref={(el) => (this.componentRef = el)} />
        </div>
        {jsonPP(this.state)}
        {jsonPP(this.context)}
      </GridContainer>
    )
  }
}

export default withStyles(styleOfGegenralApplicationTemplate, { withTheme: true })(GeneralApplicationTemplate)
